module.exports = __webpack_public_path__ + "static/media/pic2.952de161.png";